// @givmo/board — the organization's connected accounts: core's `/org/{org_ref}/integrations` family
// (CBG-CAL1 slice 1d; backend contract `org-integrations.md` §4).
//
// A calendar connection is org machinery on core, not a Board record: an account outside Givmo the
// organization lets Givmo use for ONE purpose (`board_meetings`). Its five console operations — start,
// complete, list, get, disconnect — are class-neutral and have no class door to re-spell, so, like the
// director port, every host passes this one factory (`BoardRuntime.connectionOperations`).
//
// Each member IS its generated operation, bound by reference (`<name>` ← `sdk.orgIntegrations<Name>`),
// and passes no `client`, so it rides the host's configured singleton: the officer's credential. Who
// may do what is core's (`org-integrations.md` §5): one's OWN calendar on `board_meeting:write`, the
// board account and anyone else's on `board_calendar:manage`, and disconnecting never gated on Board
// being on. While `ORG_INTEGRATIONS_ENABLED` (or the console) is off, every member answers the
// console's route miss, which the calendar's reads take as "not served" (`calendar-queries.ts`).

import { sdk } from '@givmo/api-client';

/** Core's connection operations, one generated operation per member. */
export function createOrgConnectionOperations() {
  return {
    completeOrgIntegrationOauth: sdk.orgIntegrationsCompleteOrgIntegrationOauth,
    disconnectOrgIntegration: sdk.orgIntegrationsDisconnectOrgIntegration,
    getOrgIntegration: sdk.orgIntegrationsGetOrgIntegration,
    listOrgIntegrations: sdk.orgIntegrationsListOrgIntegrations,
    startOrgIntegrationOauth: sdk.orgIntegrationsStartOrgIntegrationOauth,
  };
}

/** What a host supplies: every member typed exactly as its generated operation. */
export type BoardConnectionOperations = ReturnType<typeof createOrgConnectionOperations>;
